/**
 * Layout Configuration - Fixed pixel dimensions
 * For dialog panels, phone preview, and fixed-size UI elements
 */

// Editor Dialog panels (px)
export const LAYOUT_EDITOR_PANEL_WIDTH = 480;
export const LAYOUT_CONTROL_PANEL_HEIGHT = 64;
export const LAYOUT_TOOLBAR_HEIGHT = 64;

/**
 * Phone preview mockup (px)
 *
 * @deprecated Use the V2 preview layout constants instead.
 * This constant is kept for backward compatibility only.
 */
export const LAYOUT_PHONE = {
  width: 280,
  height: 560,
  borderWidth: 8,
  borderRadius: 4,
} as const;

// Media preview (px)
export const LAYOUT_MEDIA_PREVIEW_HEIGHT = 150;

// Content area (MUI units)
export const LAYOUT_CONTENT_PADDING = 2.5;
